import { Link } from "react-router-dom";
import { DatabaseBackup, FileSpreadsheet, History, KeyRound, Server, UserCog } from "lucide-react";

const POINTS = [
  { icon: DatabaseBackup, title: "Backup automatici", text: "Copia giornaliera dei dati e degli allegati, conservazione 30 giorni, ripristino gestito dall'assistenza." },
  { icon: UserCog, title: "Permessi granulari", text: "Ruoli e permessi per reparto: chi vede i costi, chi timbra le fasi, chi approva i preventivi." },
  { icon: FileSpreadsheet, title: "I dati restano tuoi", text: "Export Excel e PDF su catalogo, giacenze, movimenti, commesse, preventivi e qualità, in qualsiasi momento." },
  { icon: History, title: "Storico immutabile", text: "Audit log su commesse, fasi, qualità e preventivi: chi ha fatto cosa, quando, con i valori precedenti." },
  { icon: KeyRound, title: "Accessi protetti", text: "Password con requisiti minimi, blocco dopo tentativi ripetuti, sessioni revocate al cambio password." },
  { icon: Server, title: "Isolamento per azienda", text: "Ogni azienda vede soltanto i propri dati: separazione applicata su tutte le interrogazioni." },
];

export function SecuritySection() {
  return (
    <section className="landing-security" id="sicurezza" data-testid="landing-security">
      <div className="landing-section-head landing-reveal">
        <p className="landing-module-num">DATI <i /> E SICUREZZA</p>
        <h2>Dove stanno i tuoi dati e come li riprendi</h2>
        <p className="landing-desc">
          La domanda giusta da fare a chiunque ti venda un software: cosa succede ai miei dati se domani cambio idea.
        </p>
      </div>

      <div className="landing-security-grid">
        {POINTS.map(({ icon: Icon, title, text }, index) => (
          <article
            className="landing-security-card landing-reveal"
            style={{ transitionDelay: `${index * 60}ms` }}
            key={title}
            data-testid={`landing-security-${index + 1}`}
          >
            <Icon size={20} />
            <b>{title}</b>
            <p>{text}</p>
          </article>
        ))}
      </div>

      <p className="landing-security-note landing-reveal" data-testid="security-note">
        Backup, tempi di conservazione, responsabili del trattamento e diritti sui dati sono descritti nelle{" "}
        <Link to="/legale/privacy">pagine legali</Link>: privacy policy, cookie policy e informativa su
        sicurezza e copie di sicurezza.
      </p>
    </section>
  );
}
